/**
 * @file: useHomeTabNavigator.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { TabNavParams } from '@euler/app/tv/pages/Home';
import { MaterialTopTabNavigationProp } from '@react-navigation/material-top-tabs';
import { useNavigation } from '@react-navigation/native';

export const useHomeTabNavigator = () => {
  return useNavigation<MaterialTopTabNavigationProp<TabNavParams>>();
};
